export default {
  SET_PRELOADER(state, payload) {
    state.isPreloader = payload
  },
  SET_LOADING(state, payload) {
    state.loading = payload
  },
  GET_REPORTS_SUCCESS(state, payload) {
    state.reports = payload.result
    state.errors.getReports = ''
  },
  GET_REPORTS_ERROR(state, error) {
    state.errors.getReports = error
  },
  GET_REPORT_TEMPLATE_SUCCESS(state, payload) {
    state.reportTemplate = payload
    state.errors.getReportTemplate = ''
  },
  GET_REPORT_TEMPLATE_ERROR(state, error) {
    state.errors.getReportTemplate = error
  },
  SET_CALCULATED_REPORT_SUCCESS(state, payload) {
    state.reportTemplate = payload.calculatedReport
    payload.validationErrors !== null ? (state.isDisabledSendReportBtn = true) : (state.isDisabledSendReportBtn = false)
    state.errors.getReportTemplate = ''
  },
  CLEAR_REPORT_TEMPLATE(state) {
    state.reportTemplate = {}
  },
  CLEAR_CONTROLS(state) {
    state.errors.controls = null
  },
  SET_VALIDATION_ERRORS(state, payload) {
    state.errors.validation = payload
  },
  CLEAR_VALIDATION_ERRORS(state) {
    state.errors.validation = []
  },
  SET_CONTROLS(state, payload) {
    state.errors.controls = payload
  },
  SET_DISABLED_SEND_REPORT_BTN(state, payload) {
    state.isDisabledSendReportBtn = payload
  },
  CALCULATE_REPORT_ERROR(state, error) {
    state.errors.calculateReport = error
  },
  SUBMIT_REPORT_ERROR(state, error) {
    state.errors.submitReport = error
  },
  DRAFT_REPORT_ERROR(state, error) {
    state.errors.draftReport = error
  },
  SET_REPORT_NAME(state, payload) {
    state.reportName = payload
  },
  SET_VISIBLE_LOGOUT_MODAL(state, payload) {
    state.isShowLogoutModal = payload
  },
  GET_REPORT_LIST_SUCCESS(state, payload) {
    state.reportList = payload
    state.errors.getReportList = ''
  },
  GET_REPORT_LIST_ERROR(state, error) {
    state.errors.getReportList = error
  },
  GET_STATISTIC_SUCCESS(state, payload) {
    state.statisticValues = payload
    state.errors.getStatistic = ''
  },
  GET_STATISTIC_ERROR(state, error) {
    state.errors.getStatistic = error
  },
  GET_STATISTIC_LOADING(state, payload) {
    state.statisticLoading = payload
  },
  CALCULATE_REPORT_LOADING(state, payload) {
    state.calculateReportLoading = payload
  },
  LOADING_SEND_REPORT(state, payload) {
    state.loadingSendReport = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/reporting/mutations.js